import React from "react";
import { useField } from "formik";
import { useDispatch } from "react-redux";

// material
import {
  Box,
  Container,
  FormControl,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  Link,
  MenuItem,
  RadioGroup,
  Radio,
  Typography,
  Stack
} from "@mui/material";

// components
import Page from "../../../components/Page";
import { FormatUnderlined } from "@material-ui/icons";

// ----------------------------------------------------------------------

export default function UploadFormInfo(props) {
  const {
    formField: { statementReportGuideline }
  } = props;

  const [statementReportGuidelineField, statementReportGuidelineMeta] =
    useField(statementReportGuideline);

  return (
    <Page title="PART: Grade/Progress/Final Report">
      <Container maxWidth="xl">
        <Box sx={{ pb: 3 }}>
          <Typography variant="h4">Report Guideline</Typography>
        </Box>
        <Stack
          direction="column"
          justifyContent="space-evenly"
          alignItems="stretch"
          spacing={4}
        >
          <List>
            <ListItem>
              <Typography>
                The submission of reports is one of the responsibilities
                accepted by C2F-PhD students. This C2F progress report/yearly
                report can be used for 3 purposes:
              </Typography>
            </ListItem>

            <ListItem>
              <ListItemText
                primary="1. Grade Report: Students must submit their progress of the project in PART 2A."
                primaryTypographyProps={{ paddingTop: 1 }}
              />
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                {`3 yrs-program > Semester 1`}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                {`5 yrs-program > Semester 1 - 2`}
              </Typography>
            </ListItem>

            <ListItem>
              <ListItemText
                primary="2. Progress Report: Students must submit their progress of the project/examination report in PART 2A + PART 2B."
                primaryTypographyProps={{ paddingTop: 1 }}
              />
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                {`3 yrs-program > Semester 2 - 5`}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                {`5 yrs-program > Semester 3 - 9`}
              </Typography>
            </ListItem>

            <ListItem>
              <ListItemText
                primary="3. Final Report: Students must submit their completion of the project within last semester of PhD program in PART 2C."
                primaryTypographyProps={{ paddingTop: 1 }}
              />
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                {`3 yrs-program > Semester 6`}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                {`5 yrs-program > Semester 10`}
              </Typography>
            </ListItem>

            <ListItem>
              <Typography variant="subtitle1" sx={{ paddingTop: 2 }}>
                Note:
              </Typography>
            </ListItem>

            <ListItem>
              <ListItemText
                primary="1) Required Output for C2F PhD Scholarship."
                primaryTypographyProps={{ paddingTop: 1 }}
              />
            </ListItem>
            <ListItem>
              <Typography>Science field</Typography>
            </ListItem>
            <ListItem>
              <Typography>
                Normal course (3 years): 1 paper of Tier 1 publication
              </Typography>
            </ListItem>
            <ListItem>
              <Typography>
                Continuing course (5 years): 1 paper of Tier 1 and 1 paper of Q1
                publication
              </Typography>
            </ListItem>
            <ListItem>
              <Typography>Social Science and Humanities</Typography>
            </ListItem>
            <ListItem>
              <Typography>
                Normal course (3 years): 1 paper of Q1 publication
              </Typography>
            </ListItem>
            <ListItem>
              <Typography>
                Continuing course (5 years): 1 paper of Q1 and 1 paper of Q2
                publication
              </Typography>
            </ListItem>

            <ListItem>
              <ListItemText
                primary="2) Jounal Ranking Database"
                primaryTypographyProps={{ paddingTop: 1 }}
              />
            </ListItem>
            <ListItem>
              <Typography>
                C2F accepts from 3 international journal ranking database:
                Scimago (SJR), CiteScore (Scopus), and Journal Citation Report
                (Web of Science).
              </Typography>
            </ListItem>

            <ListItem>
              <ListItemText
                primary="3) The authorship and affiliation of publication submitted to C2F"
                primaryTypographyProps={{ paddingTop: 1 }}
              />
            </ListItem>
            <ListItem>
              <Typography>
                A PhD grantee requires to be a "First author".
              </Typography>
            </ListItem>
            <ListItem>
              <Typography>
                A mentor grantee requires to be a "Corresponding author".
              </Typography>
            </ListItem>
            <ListItem>
              <Typography>
                Collaborator(s) from Top 100 University Ranking/ Subject Ranking
                or Top institute or High performance professor can be
                "Co-Author" or else. (**Ranking reference is QS or Times Higher
                Education)
              </Typography>
            </ListItem>
            <ListItem>
              <Typography>
                Affliation has to identify "Chulalongkorn University".
              </Typography>
            </ListItem>

            <ListItem>
              <ListItemText
                primary="4) The acknowledgement"
                primaryTypographyProps={{ paddingTop: 1 }}
              />
            </ListItem>
            <ListItem>
              <Typography>
                Please state: “This research project is supported by the Second
                Century Fund (C2F), Chulalongkorn University”.
              </Typography>
            </ListItem>

            <ListItem>
              <ListItemText
                primary="5) Phd grantee, who submits the published article to C2F before ending of the contract, is required to send 6 month progress report.
                "
                primaryTypographyProps={{ paddingTop: 1 }}
              />
            </ListItem>

            <ListItem>
              <ListItemText
                primary="6) When grantee completes this online report, it will be automatically sent to your email, mentor's email, and C2F system."
                primaryTypographyProps={{ paddingTop: 1 }}
              />
            </ListItem>

            <ListItem>
              <Typography variant="subtitle1" sx={{ paddingTop: 2 }}>
                Please kindly check the completion before submitting to the
                system, C2F will not responsible for the incompletion in any
                cases.
              </Typography>
            </ListItem>
          </List>

          <FormControl fullWidth sx={{ paddingLeft: 2 }}>
            <Typography variant="subtitle2">
              Have you read entire statement in report guideline? *
            </Typography>
            <RadioGroup
              row
              name={statementReportGuidelineField.name}
              value={statementReportGuidelineField.value}
              onChange={(e) => statementReportGuidelineField.onChange(e)}
            >
              <FormControlLabel
                value="yes"
                control={<Radio />}
                label="Yes, I have read and accepted."
              />
            </RadioGroup>
            {statementReportGuidelineMeta.touched && (
              <span
                style={{
                  color: "#FF4842",
                  lineHeight: 1.5,
                  fontSize: "0.75rem",
                  fontFamily: "sans-serif",
                  fontWeight: 400,
                  textAlign: "left",
                  marginTop: "3px",
                  marginRight: "14px",
                  marginBottom: 0,
                  marginLeft: "14px"
                }}
              >
                {statementReportGuidelineMeta.error}
              </span>
            )}
          </FormControl>
        </Stack>
      </Container>
    </Page>
  );
}
